<template>
  <div class="progress-circle" :class="$attrs.class">
    <svg :width="size" :height="size" :viewBox="`0 0 ${size} ${size}`">
      <!-- Hintergrundkreis -->
      <circle
        class="circle-bg"
        :r="radius"
        :cx="center"
        :cy="center"
      />
      <!-- Fortschrittskreis -->
      <circle
        class="circle"
        :r="radius"
        :cx="center"
        :cy="center"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="dashOffset"
      />
      <!-- Text in der Mitte -->
      <text :x="center" :y="center + 4" class="percentage" text-anchor="middle">
        {{ showPercent ? percent + '%' : '' }}
      </text>
    </svg>
  </div>
</template>


<script>
export default {
  inheritAttrs: false,
  props: {
    percent: { type: Number, default: 70 },
    size: { type: Number, default: 40 }, // px
    showPercent: { type: Boolean, default: true },
  },
  computed: {
    radius() {
      return (this.size - 4) / 2; // 2px padding inside SVG
    },
    center() {
      return this.size / 2;
    },
    circumference() {
      return 2 * Math.PI * this.radius;
    },
    dashOffset() {
      const pct = Math.min(Math.max(this.percent, 0), 100);
      return this.circumference * (1 - pct / 100);
    },
  },
};
</script>

<style scoped>
.progress-circle {
  display: inline-block;
}
.circle-bg {
  fill: none;
  stroke: #eee;
  stroke-width: 4;
}
.circle {
  fill: none;
  stroke: #0d6efd; /* Bootstrap primary */
  stroke-width: 4;
  stroke-linecap: round;
  transform: rotate(-90deg);
  transform-origin: center;
  transition: stroke-dashoffset 0.35s ease;
}
.percentage {
  font-size: 0.5rem;
  fill: currentColor;
  font-weight: bold;
}
</style>
